import React from 'react'
import PropTypes from 'prop-types'
import { DragDrop, StatusBar } from '@uppy/react'

import Box from '../Box'

import '@uppy/status-bar/dist/style.css'
import styles from './styles.scss'

const FileUploadZone = (props) => {
  const {
    boxProps,
    height,
    style,
    subTitle,
    uppy,
  } = props

  return (
    !!uppy && (
      <Box flexDirection="column" className={styles.root} style={style} {...boxProps}>
        <DragDrop uppy={uppy} note={subTitle} height={height} />
        <StatusBar uppy={uppy} />
      </Box>
    )
  )
}

FileUploadZone.propTypes = {
  boxProps: PropTypes.object,
  height: PropTypes.string,
  style: PropTypes.object,
  subTitle: PropTypes.string,
  uppy: PropTypes.object.isRequired,
}

FileUploadZone.defaultProps = {
  allowedFileTypes: 'image/*',
  height: '180px',
  requestOptions: {},
  subTitle: 'Max 13mb each',
}

export default FileUploadZone
